import React, { memo } from 'react';
import styled from 'styled-components';

interface IClientOrderListSkeleton {
  className?: string;
  count?: number;
}

const ClientOrderListSkeleton = ({
  count = 2,
  className = '',
}: IClientOrderListSkeleton) => (
  <StyledClientOrderListSkeleton className={className}>
    {[...Array(count)].map(() => (
      <StyledOrderSkeleton />
    ))}
  </StyledClientOrderListSkeleton>
);

const StyledClientOrderListSkeleton = styled.div`
  animation: fade 0.1s ease;
  @keyframes fade {
    from {
      opacity: 0;
    }
  }
`;

const StyledOrderSkeleton = styled.div`
  border-radius: 7px;
  border: 1px solid #c2c5cc;
  height: 65px;
  margin-bottom: 5px;
  width: 100%;
`;

export default memo(ClientOrderListSkeleton);
